import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Box, Button, ClickAwayListener, Popover, Typography } from '@mui/material';

import { getRoute } from '@common/constants/CampusRoutes';
import { ICertificateModel } from '@common/models/Certificates/Certificate';

interface DetailsPopoverProps {
	certificateModel: ICertificateModel;
}

const PRODUCTS_WITHOUT_SCORE_GRADE = ['smart-teens', 'star-kids'];

function DetailsPopover({ certificateModel }: DetailsPopoverProps) {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const anchorRef = useRef<HTMLButtonElement | null>(null);
	const navigate = useNavigate();

	const handleToggle = () => {
		setOpen((prev) => !prev);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleGo = () => {
		navigate(getRoute(['PROGRAMS']));
	};

	const statsKeys = certificateModel?.statistics?.averageStats
		? Object.keys(certificateModel.statistics.averageStats).filter(
				(stats) =>
					stats !== 'scoreGrade' ||
					!PRODUCTS_WITHOUT_SCORE_GRADE.includes(certificateModel.product),
			)
		: [];

	return (
		<>
			<Button
				variant="outlined"
				size="small"
				onClick={handleToggle}
				ref={anchorRef}
				sx={{ fontSize: '14px' }}
				fullWidth
			>
				{t('certificates.details')}
			</Button>
			<Popover
				open={open}
				anchorEl={anchorRef.current}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				PaperProps={{
					sx: {
						borderRadius: 2,
						p: 2,
						mt: 1,
						width: 290,
						boxShadow: 4,
					},
				}}
			>
				<ClickAwayListener onClickAway={handleClose}>
					{certificateModel?.statistics?.averageStats ? (
						<Box>
							<Box display="flex" alignItems="center" mb={1}>
								<Typography variant="subtitle2">{t('certificates.requirements')} 🏆:</Typography>
							</Box>

							<Box p={0} mb="8px">
								{statsKeys.map((stats, index) => (
									<Typography variant="body2" key={index} p="3px 0">
										{
											// @ts-ignore
											`${certificateModel.statistics.averageStats[stats]?.isPassed ? '✅' : '❌'} ${t(`certificates.${stats}`)}`
										}
									</Typography>
								))}
							</Box>
							{!certificateModel.certificateLevel && (
								<Button
									variant="contained"
									size="small"
									sx={{ fontSize: '14px' }}
									onClick={handleGo}
									fullWidth
								>
									Let’s gooo
								</Button>
							)}
						</Box>
					) : (
						<Box>
							<Typography variant="body2" p="3px 0">
								{t('certificates.averageNull')}
							</Typography>
						</Box>
					)}
				</ClickAwayListener>
			</Popover>
		</>
	);
}

export default DetailsPopover;
